// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"1d34fd0e","453":"4ba61694"}[chunkId] + ".chunk.js";
};